import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControlBase } from './form-control-base';
import { IMyDpOptions } from "mydatepicker";

@Component({
    selector: 'df-field',
    template: require('./dynamic-form-field.html'),
    styles: [require('./dynamic-form-field.css')]
})
export class DynamicFormFieldComponent {
    @Input() field: FormControlBase<any>;
    @Input() form: FormGroup;
    @Output() selectedValueChanged = new EventEmitter<{id: string, value: string, selectedIndex: string}>();
    public get isValid() { return this.form.controls[this.field.key].valid; }
    private isText = false;
    private dateFormat: string = 'yyyy-mm-dd';
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };

    private patternMessage(): string {
        if (this.field.validNoNumber) {
            return 'Only alphabetic characters are allowed.';
        }
        if (this.field.validEmail) {
            return 'Valid email required.';
        }
        //this.field.validNumberOnly
        return 'Only numeric characters are allowed.';
    }

    private listFormatter(data: any): string {
        return data.value;
    }

    private onValueChange(event){
        this.selectedValueChanged.emit({
            id: event.target.id, value: event.target.value, selectedIndex: event.target.selectedIndex
        });
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/dynamic-form-field.component.ts